import "whatwg-fetch";
import classnames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import * as ReactDOM from "react-dom";
import { Permissions } from "../shared/model/AllPermissions";
import { Utilities } from "../shared/utilities";
import * as Notifications from "./NotificationMessageNotifier";
var NotificationMessageNotifier = Notifications.NotificationMessageNotifier;
class App extends React.Component {
    constructor(props) {
        super(props);
        this.base = "";
        this.currentAgentGroupEnvironment = {};
        this.getAuthenticationItems = () => {
            if (this.props.isAuthenticated === "True") {
                if (this.props.isSigninsupported === "True") {
                    return React.createElement(NavDropdown, { pullRight: true, id: "signout-dropdown", title: this.props.username },
                        React.createElement(MenuItem, { href: this.base + "Account/SignOut" }, FRENDS.Localizations.SignOut));
                }
                else {
                    return React.createElement("li", { role: "presentation" },
                        React.createElement("p", { className: "navbar-text" },
                            React.createElement("span", { className: "glyphicon glyphicon-user" }),
                            " ",
                            this.props.username));
                }
            }
            else if (this.props.isSigninsupported === "True") {
                return React.createElement(NavItem, { href: this.base + "Account/SignIn" }, FRENDS.Localizations.SignIn);
            }
        };
        this.getDropdownMenu = (link, linkIndex) => {
            const menuItems = link.children.map((childLink, childLinkIndex) => {
                if (this.state.hasRightsFor[childLink.permission]) {
                    const linkId = `nav_link_${linkIndex}_${childLinkIndex}`;
                    return React.createElement(MenuItem, { id: linkId, key: linkId, className: classnames("dropdown-menu-item menu-item-reversed-padding", { selected: (this.state.activeLink === childLink.activeLinkName) }), href: this.generateHref(childLink) }, childLink.label);
                }
                else {
                    return null;
                }
            });
            return React.createElement(NavDropdown, { id: "nav_link_" + linkIndex, key: "nav_link_" + linkIndex, eventKey: linkIndex, title: link.label, className: classnames({ active: (link.children.some((x) => x.activeLinkName === this.state.activeLink)) }) }, menuItems);
        };
        this.generateHref = (link) => {
            if (!link.overwriteCurrentEnvironmentInUrl) {
                return this.base + link.href;
            }
            const environment = this.getEnvironmentFromUrl();
            return this.base + link.href + environment.environmentName + (link.useAgentGroups ? environment.agentGroupName : "");
        };
        this.state = {
            activeLink: undefined,
            hasRightsFor: {}
        };
        this.tick = this.tick.bind(this);
        this.tickIntervalId = setInterval(this.tick, 500);
    }
    componentDidMount() {
        try {
            this.setState({ hasRightsFor: Utilities.getAllUserPermissions() });
        }
        catch (exception) {
            console.error("Unable to retrive user permissions: " + exception);
            throw exception;
        }
        this.updateState();
    }
    render() {
        return (React.createElement(Navbar, { className: "navbar-static-top" },
            React.createElement(Navbar.Header, null,
                React.createElement(Navbar.Brand, null,
                    React.createElement("a", { href: this.base + "Dashboard" },
                        React.createElement("img", { src: this.base + "Content/Images/frends_logo.svg", width: "150", height: "32" }))),
                React.createElement(Navbar.Toggle, null)),
            React.createElement(Navbar.Collapse, null,
                React.createElement(Nav, { id: "menu" }, navigationBarData.map((link, linkIndex) => this.state.hasRightsFor[link.permission] ?
                    link.children != null
                        ? this.getDropdownMenu(link, linkIndex)
                        : React.createElement(NavItem, { href: this.generateHref(link), className: classnames({ active: (this.state.activeLink === link.activeLinkName) }), key: link.activeLinkName }, link.label)
                    : null)),
                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                    this.props.intercomAppId === "" ? React.createElement(NavItem, { target: "_blank", href: "https://docs.frends.com/" }, FRENDS.Localizations.Help) :
                        React.createElement(NavItem, { id: "intercom_chat_launcher", href: `mailto:${this.props.intercomAppId}@hiq-finland-oy-4347f501d756.intercom-mail.com` },
                            React.createElement("i", { className: "fa fa-comment", "aria-hidden": "true" }),
                            " ",
                            FRENDS.Localizations.Help),
                    this.getAuthenticationItems()),
                React.createElement(NotificationMessageNotifier, { className: "hide-for-small-screen" }))));
    }
    tick() {
        try {
            const env = this.getEnvironmentFromUrl();
            if (!_.isEqual(env, this.currentAgentGroupEnvironment)) {
                this.updateState();
            }
        }
        catch (ex) {
            clearInterval(this.tickIntervalId);
            throw ex;
        }
    }
    updateState() {
        this.base = document.getElementsByTagName("base")[0].href;
        this.currentAgentGroupEnvironment = this.getEnvironmentFromUrl();
        const urlParts = this.getUriPartsWithoutBase();
        const controller = urlParts[0];
        this.setState({ activeLink: LinkNames[controller.toLowerCase()] });
    }
    getUriPartsWithoutBase() {
        const urlPart = window.location.href;
        const basePart = this.base;
        const urlPartWithoutBase = urlPart.replace(basePart, "").split("/");
        return urlPartWithoutBase;
    }
    getEnvironmentFromUrl() {
        const urlParts = this.getUriPartsWithoutBase();
        let environmentPart = "";
        let agentGroupPart = "";
        switch (this.state.activeLink) {
            case LinkNames.process:
            case LinkNames.subprocess:
                if ((urlParts[1] === "List") && urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                    agentGroupPart = urlParts.length >= 4 ? "/" + urlParts[3] : "";
                }
                break;
            case LinkNames.environmentvariables:
            case LinkNames.monitoringrules:
                if (urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                }
                break;
            case LinkNames.environment:
            case LinkNames.apimanagement:
                if (urlParts.length >= 2) {
                    environmentPart = "/" + urlParts[1];
                    agentGroupPart = urlParts.length >= 3 ? "/" + urlParts[2] : "";
                }
                break;
            default:
                environmentPart = "";
        }
        return { agentGroupName: agentGroupPart, environmentName: environmentPart };
    }
}
var LinkNames;
(function (LinkNames) {
    LinkNames[LinkNames["apimanagement"] = 0] = "apimanagement";
    LinkNames[LinkNames["process"] = 1] = "process";
    LinkNames[LinkNames["subprocess"] = 2] = "subprocess";
    LinkNames[LinkNames["environmentvariables"] = 3] = "environmentvariables";
    LinkNames[LinkNames["administration"] = 4] = "administration";
    LinkNames[LinkNames["environment"] = 5] = "environment";
    LinkNames[LinkNames["task"] = 6] = "task";
    LinkNames[LinkNames["monitoringrules"] = 7] = "monitoringrules";
    LinkNames[LinkNames["usermanagement"] = 8] = "usermanagement";
    LinkNames[LinkNames["apikeymanagement"] = 9] = "apikeymanagement";
    LinkNames[LinkNames["apiaccesspolicymanagement"] = 10] = "apiaccesspolicymanagement";
    LinkNames[LinkNames["settings"] = 11] = "settings";
})(LinkNames || (LinkNames = {}));
const navigationBarData = [
    { href: "ApiManagement", activeLinkName: LinkNames.apimanagement, label: FRENDS.Localizations.ApiManagement, permission: Permissions.ApiManagementView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "Process/List", activeLinkName: LinkNames.process, label: FRENDS.Localizations.Processes, permission: Permissions.ProcessView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "SubProcess/List", activeLinkName: LinkNames.subprocess, label: FRENDS.Localizations.Subprocesses, permission: Permissions.SubProcessEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "EnvironmentVariables/List", activeLinkName: LinkNames.environmentvariables, label: FRENDS.Localizations.EnvironmentVariables, permission: Permissions.EnvironmentVariablesEdit, overwriteCurrentEnvironmentInUrl: true },
    {
        href: "", activeLinkName: LinkNames.administration, label: FRENDS.Localizations.Administration, permission: Permissions.AdministrationView, overwriteCurrentEnvironmentInUrl: false,
        children: [
            { href: "Environment", activeLinkName: LinkNames.environment, label: FRENDS.Localizations.Environments, permission: Permissions.EnvironmentEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
            { href: "Task", activeLinkName: LinkNames.task, label: FRENDS.Localizations.Tasks, permission: Permissions.TaskView, overwriteCurrentEnvironmentInUrl: false },
            { href: "MonitoringRules/List", activeLinkName: LinkNames.monitoringrules, label: FRENDS.Localizations.MonitoringRules, permission: Permissions.MonitoringRulesView, overwriteCurrentEnvironmentInUrl: true },
            { href: "UserManagement", activeLinkName: LinkNames.usermanagement, label: FRENDS.Localizations.UserManagement, permission: Permissions.UserManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiKeyManagement", activeLinkName: LinkNames.apikeymanagement, label: FRENDS.Localizations.Administration_ApiKeys, permission: Permissions.ApiKeyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiAccessPolicyManagement", activeLinkName: LinkNames.apiaccesspolicymanagement, label: FRENDS.Localizations.ApiAccessPolicies, permission: Permissions.ApiAccessPolicyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "Settings", activeLinkName: LinkNames.settings, label: FRENDS.Localizations.Settings, permission: Permissions.SettingsAdmin, overwriteCurrentEnvironmentInUrl: false }
        ]
    }
];
const navigationContainer = document.getElementById("navigationbar");
if (navigationContainer) {
    const render = (Component) => ReactDOM.render((React.createElement(Component, Object.assign({}, (navigationContainer.dataset)))), navigationContainer);
    render(App);
}
